import { FaCode, FaMobile, FaPalette, FaServer, FaShieldAlt, FaRocket } from "react-icons/fa";

export default function Services() {
  const services = [
    {
      icon: <FaCode />,
      title: "Web Development",
      desc: "Modern and responsive websites using React & Tailwind",
      color: "from-blue-500 to-cyan-400"
    },
    {
      icon: <FaMobile />,
      title: "Mobile Apps",
      desc: "Cross-platform apps with Flutter & React Native",
      color: "from-purple-500 to-pink-400"
    },
    {
      icon: <FaPalette />,
      title: "UI/UX Design",
      desc: "Clean and user-friendly interface design",
      color: "from-orange-400 to-yellow-400"
    },
    {
      icon: <FaServer />,
      title: "Backend Development",
      desc: "Secure APIs using Node.js & Express",
      color: "from-green-500 to-emerald-400"
    },
    {
      icon: <FaShieldAlt />,
      title: "Authentication",
      desc: "JWT-based secure login systems",
      color: "from-red-500 to-rose-400"
    },
    {
      icon: <FaRocket />,
      title: "Deployment",
      desc: "Fast and reliable hosting with Netlify & more",
      color: "from-indigo-500 to-blue-400"
    },
  ];

  return (
    <section className="py-16 px-4 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-green-500/10 border border-green-500/20 rounded-full text-green-600 text-xs font-semibold tracking-wider uppercase mb-3">
            What We Offer
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-500 to-emerald-400">Services</span>
          </h2>
          <p className="mt-3 text-gray-500 text-sm sm:text-base max-w-2xl mx-auto">
            Comprehensive solutions to bring your digital vision to life
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <div
              key={i}
              className="group relative bg-white rounded-2xl p-6 text-left border border-gray-100 hover:border-green-200 transition-all duration-300 hover:shadow-xl hover:shadow-green-500/10 hover:-translate-y-2"
            >
              {/* Icon */}
              <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${service.color} flex items-center justify-center text-white text-2xl mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                {service.icon}
              </div>

              {/* Title */}
              <h3 className="text-lg font-bold text-gray-800 mb-2">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-sm text-gray-500 leading-relaxed">
                {service.desc}
              </p>

              {/* Learn More Link */}
              <div className="mt-4 flex items-center gap-1 text-green-500 font-medium text-sm group-hover:gap-2 transition-all duration-300">
                <span>Learn More</span>
                <span className="text-xs">→</span>
              </div>

              {/* Decorative Line */}
              <div className="absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-green-500 to-emerald-400 rounded-full group-hover:w-full transition-all duration-500"></div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-500 text-sm mb-4">
            Need a custom solution? Let's talk about your project
          </p>
          <button className="px-8 py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl font-semibold shadow-lg shadow-green-500/30 hover:shadow-green-500/50 hover:scale-105 transition-all duration-300">
            Get a Free Quote
          </button>
        </div>
      </div>
    </section>
  );
}